/*
Copyright (c) 2015, salesforce.com, inc. All rights reserved.
Copyright (c) 2019, Picsa Advisory Services (Pty) Ltd. All rights reserved.

Redistribution and use in source and binary forms, with or without modification, are permitted provided that the following conditions are met:
Redistributions of source code must retain the above copyright notice, this list of conditions and the following disclaimer.
Redistributions in binary form must reproduce the above copyright notice, this list of conditions and the following disclaimer in the documentation and/or other materials provided with the distribution.
Neither the name of salesforce.com, inc. nor the names of its contributors may be used to endorse or promote products derived from this software without specific prior written permission.

THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS 'AS IS' AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES LOSS OF USE, DATA, OR PROFITS OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
*/

import React from 'react'
import PropTypes from 'prop-types'
import { Query } from 'react-apollo'

import {
  Spinner,
  Warning,
  SelectBadges
} from '../'

import {
  QUERY_REQUESTTYPES
} from '../../queries'


export class ChooseRequestType extends React.PureComponent {
  static propTypes = {
    value: PropTypes.string,
    onChange: PropTypes.func.isRequired,
    className: PropTypes.string
  }

  render() {
    return (
      <Query query={QUERY_REQUESTTYPES} variables={{ audience: 'client', source: 'agent_capture' }}>
        {({ loading, error, data }) => {
          if (loading) {
            return <Spinner className='slds-is-relative slds-m-left_large' size='x-small' />
          }
          if (error) {
            return (
              <Warning inline={true} className='slds-m-left_small' iconSize='x-small'>
                Failed to load options.
              </Warning>
            )
          }

          let applicationRequestTypes = []
          let documentRequestTypes = []
          let otherRequestTypes = []

          data.requesttypes.edges
          // first filter out legacy request types
          .filter(( { node: requestType }) => (
            requestType.name.toLowerCase().includes('(old)') === false &&
            requestType.name.includes(' OLD ') === false  // catches 'Loan OLD (Page 2)'
          ))
          // now populate according to request type categories "Applications", "Documents" & "Other"
          .forEach(({ node: requestType }) => {
            let prefix = null
            let name = null

            if (requestType.name.includes(': ')) {
              [ prefix, name ] = requestType.name.split(': ')
              // if request type name does not have a family prefix matching 'Application' or 'Document', to show name incl. prefix as request run label under 'Other' section
              if (['Application', 'Document'].indexOf(prefix) === -1) {
                name = requestType.name
              }
            } else {
              // if request type name has not prefix-part, the whole name should be displayed as label in listing
              name = requestType.name
            }

            if (prefix === 'Application') {
              applicationRequestTypes.push({
                value: requestType.id,
                label: name
              })
            } else if (prefix === 'Document') {
              documentRequestTypes.push({
                value: requestType.id,
                label: name
              })
            } else {
              otherRequestTypes.push({
                value: requestType.id,
                label: name
              })
            }
          })

          return (
            <div>
              <div className='u-font-size-larger u-font-weight-bold'>
                Choose request type
              </div>
              {applicationRequestTypes.length > 0 &&
                <div className='slds-m-top_medium'>
                  Applications
                  <div className='slds-grid slds-wrap'>
                    <SelectBadges
                      id='applicationRequestTypes'
                      value={this.props.value}
                      options={applicationRequestTypes}
                      onChange={this.props.onChange}
                    />
                  </div>
                </div>
              }
              {documentRequestTypes.length > 0 &&
                <div className='slds-m-top_medium'>
                  Documents
                  <div className='slds-grid slds-wrap'>
                    <SelectBadges
                      id='documentRequestTypes'
                      value={this.props.value}
                      options={documentRequestTypes}
                      onChange={this.props.onChange}
                    />
                  </div>
                </div>
              }
              {otherRequestTypes.length > 0 &&
                <div className='slds-m-top_medium'>
                  Other
                  <div className='slds-grid slds-wrap'>
                    <SelectBadges
                      id='otherRequestTypes'
                      value={this.props.value}
                      options={otherRequestTypes}
                      onChange={this.props.onChange}
                    />
                  </div>
                </div>
              }
            </div>
          )}
        }
      </Query>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/request-classify-form/ChooseRequestType.js